/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Meta_TitleInputs */

const en_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice Hub | Mark Egly Golf`)
};

const es_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de práctica | Mark Egly Golf`)
};

const de_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungszentrum | Mark Egly Golf`)
};

const zh_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习中心 | Mark Egly Golf`)
};

const ar_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مركز التدريب | Mark Egly Golf`)
};

const fr_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de pratique | Mark Egly Golf`)
};

const vi_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trung tâm luyện tập | Mark Egly Golf`)
};

const sw_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitovu cha Mazoezi | Mark Egly Golf`)
};

const th_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ศูนย์ฝึกซ้อม | Mark Egly Golf`)
};

const bs_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centar za vježbanje | Mark Egly Golf`)
};

const ja_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`練習センター | Mark Egly Golf`)
};

const ko_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연습 센터 | Mark Egly Golf`)
};

const pt_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central de prática | Mark Egly Golf`)
};

const it_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro di allenamento | Mark Egly Golf`)
};

const sv_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Träningscenter | Mark Egly Golf`)
};

const nl_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefencentrum | Mark Egly Golf`)
};

const da_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træningscenter | Mark Egly Golf`)
};

const nb_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningssenter | Mark Egly Golf`)
};

const fi_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoituskeskus | Mark Egly Golf`)
};

const pl_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum treningowe | Mark Egly Golf`)
};

const ru_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренировочный центр | Mark Egly Golf`)
};

const tr_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenman Merkezi | Mark Egly Golf`)
};

const hi_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभ्यास केंद्र | Mark Egly Golf`)
};

const id_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Latihan | Mark Egly Golf`)
};

const ms_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hab Latihan | Mark Egly Golf`)
};

const cs_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tréninkové centrum | Mark Egly Golf`)
};

const el_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κέντρο εξάσκησης | Mark Egly Golf`)
};

const he_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מרכז תרגול | Mark Egly Golf`)
};

const af_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefensentrum | Mark Egly Golf`)
};

const hu_practice_meta_title = /** @type {(inputs: Practice_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlóközpont | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Practice Hub \| Mark Egly Golf" |
*
* @param {Practice_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_meta_title = /** @type {((inputs?: Practice_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_meta_title(inputs)
	if (locale === "de") return de_practice_meta_title(inputs)
	if (locale === "zh") return zh_practice_meta_title(inputs)
	if (locale === "ar") return ar_practice_meta_title(inputs)
	if (locale === "fr") return fr_practice_meta_title(inputs)
	if (locale === "vi") return vi_practice_meta_title(inputs)
	if (locale === "sw") return sw_practice_meta_title(inputs)
	if (locale === "th") return th_practice_meta_title(inputs)
	if (locale === "bs") return bs_practice_meta_title(inputs)
	if (locale === "ja") return ja_practice_meta_title(inputs)
	if (locale === "ko") return ko_practice_meta_title(inputs)
	if (locale === "pt") return pt_practice_meta_title(inputs)
	if (locale === "it") return it_practice_meta_title(inputs)
	if (locale === "sv") return sv_practice_meta_title(inputs)
	if (locale === "nl") return nl_practice_meta_title(inputs)
	if (locale === "da") return da_practice_meta_title(inputs)
	if (locale === "nb") return nb_practice_meta_title(inputs)
	if (locale === "fi") return fi_practice_meta_title(inputs)
	if (locale === "pl") return pl_practice_meta_title(inputs)
	if (locale === "ru") return ru_practice_meta_title(inputs)
	if (locale === "tr") return tr_practice_meta_title(inputs)
	if (locale === "hi") return hi_practice_meta_title(inputs)
	if (locale === "id") return id_practice_meta_title(inputs)
	if (locale === "ms") return ms_practice_meta_title(inputs)
	if (locale === "cs") return cs_practice_meta_title(inputs)
	if (locale === "el") return el_practice_meta_title(inputs)
	if (locale === "he") return he_practice_meta_title(inputs)
	if (locale === "af") return af_practice_meta_title(inputs)
	if (locale === "hu") return hu_practice_meta_title(inputs)
	return en_practice_meta_title(inputs)
});